export enum SuggestionType {
    destination = 'destination',
    hotel = 'hotel',
    airport = 'airport',
    viewpoint = 'viewpoint'
}
